export default "__VITE_ASSET__CAYljEqH__"